define('views/modules/questionnaire/responses/response-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/media-info-box',
    'views/modules/questionnaire/modal/questionnaire-responses-download-modal',
    // templates
    'text!templates/modules/questionnaire/responses/response-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // views
    VMediaInfoBox,
    VQuestionnaireResponsesDownloadModal,
    // templates
    TResponseListItem
) {

    var VResponseListItem = Backbone.View.extend({
        template: TResponseListItem,

        regions: {
            infobox: ".item-section",
            subSection: ".sub-section",
        },
        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'displayName',
                    customSubtitle: this.model.get('_questionnaire').get('title'),
                    photo: "thumbnail",
                    timeago: this.getTimeAgoDate(),
                    model: this.model.getComputedUser(),
                    context: this,
                    onClick: this.onResponseClick,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    }
                }),
            };

            this.listenTo(this.model, {
                'remove': this.remove,
            });
        },
        render: function() {

            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones()
                .assign(this.view.infobox, this.regions.infobox);

            return this;
        },

        deleteResponse: function(result) {
            if (!result) return;
            this.model.destroy({
                context: this,
                wait: true,
                error: function(model, response) {
                    if (response.responseJSON) {
                        U.warn(response.responseJSON.message);
                    }
                }
            });
        },

        getTimeAgoDate: function() {
            var timestamp = this.model.getTimeStampObject();
            var fromNow = timestamp.fromNow();
            timestamp = timestamp.local();

            return { 'fromNow': fromNow, 'timestamp': timestamp };
        },

        ////////////
        // events //
        ////////////

        onMenuInit: function() {
            return new Backbone.Collection([
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction },
                { caption: 'calendar:Download', icon: "sl-icon-cloud-download", callback: this.onDownloadAction },
            ]);
        },

        onResponseClick: function(e) {
            this.model.trigger("response:click", this.model);
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: "Delete response",
                message: i18n.t("messages:message-delete-response"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteResponse,
                context: this,
            });
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onDownloadAction: function () {
            var modal = new VQuestionnaireResponsesDownloadModal({ model: this.model, group: this.group });
            modal.render();
        }
    });

    return VResponseListItem;

});

